import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import TwoFactorSetup from './components/TwoFactorSetup';
import TwoFactorVerify from './components/TwoFactorVerify';
import Dashboard from './components/Dashboard';
import './App.css';

export default function App() {
  const [user, setUser] = useState(null);
  const [pendingState, setPendingState] = useState(null); // 'setup' | 'verify' | null
  const [tempToken, setTempToken] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('finance_token');
    const stored = localStorage.getItem('finance_user');
    if (token && stored) {
      try { setUser(JSON.parse(stored)); } catch { /* ignore */ }
    }
  }, []);

  const handleLoginResult = (data) => {
    if (data.requires_2fa_setup) {
      setTempToken(data.temp_token);
      setPendingState('setup');
    } else if (data.requires_2fa) {
      setTempToken(data.temp_token);
      setPendingState('verify');
    } else {
      localStorage.setItem('finance_token', data.token);
      localStorage.setItem('finance_user', JSON.stringify(data.user));
      setUser(data.user);
    }
  };

  const handle2faSuccess = (userData, token) => {
    localStorage.setItem('finance_token', token);
    localStorage.setItem('finance_user', JSON.stringify(userData));
    setPendingState(null);
    setTempToken(null);
    setUser(userData);
  };

  const handleBack = () => {
    setPendingState(null);
    setTempToken(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('finance_token');
    localStorage.removeItem('finance_user');
    setUser(null);
    setPendingState(null);
    setTempToken(null);
  };

  if (pendingState === 'setup' && tempToken) {
    return <TwoFactorSetup tempToken={tempToken} onSuccess={handle2faSuccess} />;
  }

  if (pendingState === 'verify' && tempToken) {
    return <TwoFactorVerify tempToken={tempToken} onSuccess={handle2faSuccess} onBack={handleBack} />;
  }

  if (!user) return <Login onLogin={handleLoginResult} />;
  return <Dashboard user={user} onLogout={handleLogout} />;
}
